import { render, staticRenderFns } from "./ApplicationFlowKYCPreparation.vue?vue&type=template&id=2eb55b03&scoped=true&"
import script from "./ApplicationFlowKYCPreparation.vue?vue&type=script&lang=js&"
export * from "./ApplicationFlowKYCPreparation.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFlowKYCPreparation.vue?vue&type=style&index=0&id=2eb55b03&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb55b03",
  null
  
)

export default component.exports